
import Vue from 'vue'

const locales = require.context('./locale', false, /.json$/)
global['____GEF92828____'] = true;
delete global['____GEF92828____'];
global.__uniConfig = {"easycom":{"^u-(.*)":"uview-ui/components/u-$1/u-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"globalStyle":{"navigationBarBackgroundColor":"#FFF","navigationBarTitleText":"Oichat","navigationStyle":"custom","navigationBarTextStyle":"black"}};
global.__uniConfig.compilerVersion = '4.66';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__GEF92828';
global.__uniConfig.appName = 'Oichat';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{}};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "en";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-agency', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/agency"+'.vue')), 'pages-activities-agency'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-weekStarNew', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/weekStarNew"+'.vue')), 'pages-activities-weekStarNew'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-weeklyCPNew', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/weeklyCPNew"+'.vue')), 'pages-activities-weeklyCPNew'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-recharge', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/recharge"+'.vue')), 'pages-activities-recharge'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-christmas', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/christmas"+'.vue')), 'pages-activities-christmas'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-christmas-eve', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/christmas-eve"+'.vue')), 'pages-activities-christmas-eve'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-newYear', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/newYear"+'.vue')), 'pages-activities-newYear'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-dragon', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/dragon"+'.vue')), 'pages-activities-dragon'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-pk', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/pk"+'.vue')), 'pages-activities-pk'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-world-pk', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/world-pk"+'.vue')), 'pages-activities-world-pk'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-ramadan', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/ramadan"+'.vue')), 'pages-activities-ramadan'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-holi', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/holi"+'.vue')), 'pages-activities-holi'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-pakistan', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/pakistan"+'.vue')), 'pages-activities-pakistan'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-bengal', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/bengal"+'.vue')), 'pages-activities-bengal'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-eidMubarak', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/eidMubarak"+'.vue')), 'pages-activities-eidMubarak'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-bengalNewYear', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/bengalNewYear"+'.vue')), 'pages-activities-bengalNewYear'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-invite', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/invite"+'.vue')), 'pages-activities-invite'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-labor', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/labor"+'.vue')), 'pages-activities-labor'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-fame', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/fame"+'.vue')), 'pages-activities-fame'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-topStar', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/topStar"+'.vue')), 'pages-activities-topStar'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-gameKing', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/gameKing"+'.vue')), 'pages-activities-gameKing'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-NayaSitara', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/activities/NayaSitara"+'.vue')), 'pages-activities-NayaSitara'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-gameActive-xiaoyou', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/gameActive/xiaoyou"+'.vue')), 'pages-gameActive-xiaoyou'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-active-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/active/index"+'.vue')), 'pages-active-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-document-agreement', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/document/agreement"+'.vue')), 'pages-document-agreement'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pay-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pay/index"+'.vue')), 'pay-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pay-bengal', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pay/bengal"+'.vue')), 'pay-bengal'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pay-confirm', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pay/confirm"+'.vue')), 'pay-confirm'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pay-confirmDana', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pay/confirmDana"+'.vue')), 'pay-confirmDana'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-racing-game-rules-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/racing/game-rules/index"+'.vue')), 'pages-racing-game-rules-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-racing-rank-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/racing/rank/index"+'.vue')), 'pages-racing-rank-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-racing-rule-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/admin/.jenkins/workspace/hayatchat-game/src/pages/racing/rule/index"+'.vue')), 'pages-racing-rule-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/activities/agency',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-agency', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-agency',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/agency',
  windowTop:0
}
},
{
path: '/pages/activities/weekStarNew',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-weekStarNew', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-weekStarNew',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/weekStarNew',
  windowTop:0
}
},
{
path: '/pages/activities/weeklyCPNew',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-weeklyCPNew', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-weeklyCPNew',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/weeklyCPNew',
  windowTop:0
}
},
{
path: '/pages/activities/recharge',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-recharge', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-recharge',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/recharge',
  windowTop:0
}
},
{
path: '/pages/activities/christmas',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-christmas', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-christmas',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/christmas',
  windowTop:0
}
},
{
path: '/pages/activities/christmas-eve',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-christmas-eve', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-christmas-eve',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/christmas-eve',
  windowTop:0
}
},
{
path: '/pages/activities/newYear',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-newYear', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-newYear',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/newYear',
  windowTop:0
}
},
{
path: '/pages/activities/dragon',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-dragon', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-dragon',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/dragon',
  windowTop:0
}
},
{
path: '/pages/activities/pk',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-pk', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-pk',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/pk',
  windowTop:0
}
},
{
path: '/pages/activities/world-pk',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-world-pk', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-world-pk',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/world-pk',
  windowTop:0
}
},
{
path: '/pages/activities/ramadan',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-ramadan', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-ramadan',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/ramadan',
  windowTop:0
}
},
{
path: '/pages/activities/holi',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-holi', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-holi',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/holi',
  windowTop:0
}
},
{
path: '/pages/activities/pakistan',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-pakistan', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-pakistan',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/pakistan',
  windowTop:0
}
},
{
path: '/pages/activities/bengal',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-bengal', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-bengal',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/bengal',
  windowTop:0
}
},
{
path: '/pages/activities/eidMubarak',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-eidMubarak', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-eidMubarak',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/eidMubarak',
  windowTop:0
}
},
{
path: '/pages/activities/bengalNewYear',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-bengalNewYear', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-bengalNewYear',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/bengalNewYear',
  windowTop:0
}
},
{
path: '/pages/activities/invite',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-invite', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-invite',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/invite',
  windowTop:0
}
},
{
path: '/pages/activities/labor',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-labor', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-labor',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/labor',
  windowTop:0
}
},
{
path: '/pages/activities/fame',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-fame', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-fame',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/fame',
  windowTop:0
}
},
{
path: '/pages/activities/topStar',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-topStar', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-topStar',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/topStar',
  windowTop:0
}
},
{
path: '/pages/activities/gameKing',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-gameKing', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-gameKing',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/gameKing',
  windowTop:0
}
},
{
path: '/pages/activities/NayaSitara',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activities-NayaSitara', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-NayaSitara',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/NayaSitara',
  windowTop:0
}
},
{
path: '/pages/gameActive/xiaoyou',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-gameActive-xiaoyou', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-gameActive-xiaoyou',
  isNVue:false,maxWidth:0,
  pagePath:'pages/gameActive/xiaoyou',
  windowTop:0
}
},
{
path: '/pages/active/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-active-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-active-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/active/index',
  windowTop:0
}
},
{
path: '/pages/document/agreement',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-document-agreement', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-document-agreement',
  isNVue:false,maxWidth:0,
  pagePath:'pages/document/agreement',
  windowTop:0
}
},
{
path: '/pay/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pay-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pay-index',
  isNVue:false,maxWidth:0,
  pagePath:'pay/index',
  windowTop:0
}
},
{
path: '/pay/bengal',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pay-bengal', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pay-bengal',
  isNVue:false,maxWidth:0,
  pagePath:'pay/bengal',
  windowTop:0
}
},
{
path: '/pay/confirm',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pay-confirm', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pay-confirm',
  isNVue:false,maxWidth:0,
  pagePath:'pay/confirm',
  windowTop:0
}
},
{
path: '/pay/confirmDana',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pay-confirmDana', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pay-confirmDana',
  isNVue:false,maxWidth:0,
  pagePath:'pay/confirmDana',
  windowTop:0
}
},
{
path: '/pages/racing/game-rules/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-racing-game-rules-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-racing-game-rules-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/racing/game-rules/index',
  windowTop:0
}
},
{
path: '/pages/racing/rank/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-racing-rank-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-racing-rank-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/racing/rank/index',
  windowTop:0
}
},
{
path: '/pages/racing/rule/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-racing-rule-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-racing-rule-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/racing/rule/index',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
